import { useQuery } from "@apollo/client";
import type {
  InvoicesByFiltersQuery,
  InvoicesByFiltersQueryVariables,
} from "@/__generated__/graphql";
import { InvoicesByFiltersDocument } from "@/__generated__/graphql";
import type { InvoiceCardData } from "@/components/shared/invoices/invoice-card";
import { mapToInvoiceCard } from "@/components/shared/invoices/invoice-card";

export function useInvoicesByFiltersQuery(
  filters: InvoicesByFiltersQueryVariables["filters"],
) {
  const result = useQuery<
    InvoicesByFiltersQuery,
    InvoicesByFiltersQueryVariables
  >(InvoicesByFiltersDocument, {
    skip: !filters?.clientId?.length,
    notifyOnNetworkStatusChange: true,
    variables: {
      filters,
    },
  });

  const rawInvoices = result.data?.invoicesByFilters?.invoices ?? [];
  const total = result.data?.invoicesByFilters?.count ?? 0;
  const list: InvoiceCardData[] = rawInvoices.map(mapToInvoiceCard);
  const canLoadMore = list.length < total;
  const loading = result.loading;

  const loadMore = () => {
    if (!canLoadMore || loading || !filters) return;
    result.fetchMore({
      variables: {
        filters: {
          ...result.variables?.filters,
          offset: list.length,
        },
      },
    });
  };

  return {
    ...result,
    list,
    total,
    canLoadMore,
    loading,
    loadMore,
  };
}
